import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58cda4f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = {
  class: "main",
  style: {"margin-right":"10px"}
}
const _hoisted_3 = { class: "mod_c_title" }
const _hoisted_4 = { class: "main_but" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主持", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thicken" }, null, -1))
const _hoisted_7 = { class: "guest" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item_text" }, "开播链接：", -1))
const _hoisted_9 = { class: "guest_item mar_bot" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1))
const _hoisted_11 = { class: "footer" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打开链接", -1))
const _hoisted_13 = { class: "qrcode" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "foot_qr_box" }
const _hoisted_16 = { class: "main" }
const _hoisted_17 = { class: "mod_c_title" }
const _hoisted_18 = { class: "main_but bg_color" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "直播端", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thicken" }, null, -1))
const _hoisted_21 = { class: "guest" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item_text" }, "观看链接：", -1))
const _hoisted_23 = { class: "guest_item mar_bot" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1))
const _hoisted_25 = { class: "footer" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打开链接", -1))
const _hoisted_27 = ["data-clipboard-text"]

import { computed, reactive, ref } from 'vue';
import ClipboardJS from 'clipboard';
import { message } from 'ant-design-vue';
import { Switch, Tooltip, Button, Input, Popover } from 'ant-design-vue';
import http from '@/api';
import router from '@/router';
import { WebLive } from './liveMode';
import { useConsoleStore } from '@/pinia/console';
import SvgIcon from '../../../components/SvgIcon.vue';
import { useQRCode } from '@vueuse/integrations/useQRCode';

// `qrcode` will be a ref of data URL

export default /*#__PURE__*/_defineComponent({
  __name: 'WebLive',
  setup(__props) {

const consoleStore = useConsoleStore();
const rehearsal = computed(() =>
  consoleStore.consoleInfo.rehearsalSwitch ? `彩排密码：${consoleStore.consoleInfo.rehearsalPwd}` : ''
);
const studioId = router.currentRoute.value.params.studioId;
const aInput = Input;
const aButton = Button;
const aSwitch = Switch;
const aTooltip = Tooltip;
const aPopover = Popover;
const state = reactive({
  readonly1: true,
  readonly2: true,
});
// 点击修改输入框
const setReadonly = (id: number) => {
  if (id === 0) {
    state.readonly1 = !state.readonly1;
    const getFocus = document.getElementById('textInput');
    if (getFocus) {
      getFocus.focus();
    }
  } else {
    state.readonly2 = !state.readonly2;
    const getFocus = document.getElementById('textInput2');
    if (getFocus) {
      getFocus.focus();
    }
  }
};
//  copy
const copyText = (btns: string) => {
  const ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', (e) => {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', () => {
    message.destroy();
    message.info('复制失败');
  });
};
//  获取网页直播 信息
const webLiveData = ref<WebLive>({
  host_password_status: false, // 主持 开关
  link: '', // 主持 开播链接
  host_password: '', // 主持 密码
  helper_password_status: false, // 参会者 开关
  helper_link: '', //参会者 开播链接
  helper_password: '', //参会者 密码
});
const getWebLive = () => {
  const data = {
    studio_id: studioId,
  };
  http.liveMode
    .getWebLive({ params: data })
    .then((res) => {
      webLiveData.value = res.data.data;
      webLiveData.value.host_password_status = res.data.data.host_password_status ? true : false;
      webLiveData.value.helper_password_status = res.data.data.helper_password_status ? true : false;
    })
    .catch(() => {
      // message
    });
};
getWebLive();
// open
const openUrl = (type: string) => {
  if (type === 'helper') {
    window.open(webLiveData.value.helper_link);
  } else window.open(webLiveData.value.link);
};

const qrcodeUrl = computed(() => webLiveData.value.link);
const qrcode = useQRCode(qrcodeUrl, {
  margin: 2,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(SvgIcon, { "icon-class": "but_main" })
          ]),
          _hoisted_5,
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(aInput), {
              value: webLiveData.value.link,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((webLiveData.value.link) = $event)),
              class: "guest_in",
              readonly: ""
            }, null, 8, ["value"]),
            _createVNode(_unref(aTooltip), { placement: "top" }, {
              title: _withCtx(() => [
                _hoisted_10
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(aButton), {
                  class: "updata_but pledgeM",
                  "data-clipboard-text": webLiveData.value.link,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (copyText('.pledgeM')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(SvgIcon, { "icon-class": "control_copy" })
                  ]),
                  _: 1
                }, 8, ["data-clipboard-text"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "open_box",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openUrl('main')))
          }, [
            _hoisted_12,
            _createTextVNode("   "),
            _createVNode(SvgIcon, { "icon-class": "but_computer" })
          ]),
          _createVNode(_unref(aPopover), null, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _unref(qrcode),
                  alt: "QR Code"
                }, null, 8, _hoisted_14)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(SvgIcon, { "icon-class": "control_qrcode" })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(SvgIcon, { "icon-class": "but_join" })
          ]),
          _hoisted_19,
          _hoisted_20
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_unref(aInput), {
              value: webLiveData.value.helper_link,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((webLiveData.value.helper_link) = $event)),
              class: "guest_in",
              readonly: ""
            }, null, 8, ["value"]),
            _createVNode(_unref(aTooltip), { placement: "top" }, {
              title: _withCtx(() => [
                _hoisted_24
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(aButton), {
                  class: "updata_but pledgeC",
                  "data-clipboard-text": webLiveData.value.helper_link,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (copyText('.pledgeC')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(SvgIcon, { "icon-class": "control_copy" })
                  ]),
                  _: 1
                }, 8, ["data-clipboard-text"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", {
            class: "open_box",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (openUrl('helper'))),
            style: {"width":"100%"}
          }, [
            _hoisted_26,
            _createTextVNode("   "),
            _createVNode(SvgIcon, { "icon-class": "but_computer" })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "one_copy pledgeA",
      "data-clipboard-text": '主持人链接：' + webLiveData.value.link + '\n' + '直播端链接：' + webLiveData.value.helper_link + '\n' + _unref(rehearsal),
      onClick: _cache[6] || (_cache[6] = ($event: any) => (copyText('.pledgeA')))
    }, " 一键复制 ", 8, _hoisted_27)
  ], 64))
}
}

})